import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from "../images/logo.png";
import { RiArrowGoBackLine } from 'react-icons/ri';
import axios from 'axios'; // Assuming you're using axios for the login request
import { buildApiUrl } from "../utils/api";

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const navigate = useNavigate();

    const requestOtp = async () => {
        try {
            await axios.post(buildApiUrl('/api/user/send-otp'), { email });
            setIsOtpSent(true);
            alert('OTP has been sent to your email.');
        } catch (err) {
            console.error('Error sending OTP:', err);
            setError('Failed to send OTP. Please try again.');
        }
    };

    const verifyOtp = async () => {
        setLoading(true);
        setError(null);

        try {
            const otpResponse = await axios.post(buildApiUrl('/api/user/verify-otp'), { email, otp });
            console.log(otpResponse.data.message);

            if (otpResponse.status === 200) {
                alert('OTP verified successfully! You can now log in.');
                // localStorage.setItem('token', response.data.token);
                // navigate('/clientDetails');
            }
        } catch (err) {
            console.error('OTP verification failed:', err);
            setError('Invalid OTP. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(buildApiUrl('/api/user/login'), { email, password });
            // Handle successful login (e.g., store token in local storage, navigate to another page)
            console.log('Login successful!', response.data);
            localStorage.setItem('token', response.data.token); // Store token
            setLoading(false);
            // Redirect user after login
            navigate('/userDetails');
        } catch (err) {
            console.error('Login failed:', err);
            setError('Invalid credentials. Please try again.');
            setLoading(false);
        }
    };

    return (
        <div className='userLogin'>
            <div className="container d-flex justify-content-center">
                <img src={Logo} alt="" style={{ width: "250px", height: "200px", marginTop: "20%", marginRight: "20px" }} />
                <div className="row text-start" style={{ marginTop: "10%" }}>
                    <form onSubmit={handleSubmit} className="login-form" style={{ padding: "2rem 6rem", backgroundColor: "#f8f9fa", borderRadius: "8px", opacity: "0.7" }}>
                        <h2 className="text-center mb-4" style={{ color: "#973131" }}>User Login</h2>

                        {error && <div className="alert alert-danger" role="alert">{error}</div>}

                        <div className="mb-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                id="exampleInputEmail1"
                                placeholder="Your E-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                            <div className="input-group">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    id="exampleInputPassword1"
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="d-flex align-items-center mt-2">
                                <input
                                    type="checkbox"
                                    id="showPassword"
                                    onClick={() => setShowPassword(!showPassword)}
                                />
                                <label htmlFor="showPassword" className="ms-2">
                                    {showPassword ? "Hide Password" : "Show Password"}
                                </label>
                            </div>
                        </div>
                        {!isOtpSent ? (
                            <button type="button" className="btn btn-secondary" onClick={requestOtp}>
                                Request OTP
                            </button>
                        ) : (
                            <div className="mb-3">
                                <label htmlFor="otpInput" className="form-label">Enter OTP</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="otpInput"
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    required
                                />
                                <button type="button" className="btn btn-secondary mt-2" onClick={verifyOtp}>
                                    Verify OTP
                                </button>
                            </div>
                        )}

                        {isOtpSent && (
                            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                                {loading ? "Logging in..." : "Submit"}
                            </button>
                        )}

                        {/* <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                            {loading ? "Logging in..." : "Submit"}
                        </button> */}
                        <div className='d-flex justify-content-center mt-3'>
                            <p>Create New Account | <Link to="/registerUser">Sign Up here</Link></p>
                        </div>

                        <div className="d-flex justify-content-center mt-2">
                            <p><Link to="/" style={{ textDecoration: "none", color: "#000" }}><RiArrowGoBackLine /> Go Back to Home Page</Link></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
